import { ActionIcon } from '@mantine/core';
import { IconSquareX } from '@tabler/icons-react';

import { COLORS } from '@/utils/colors';

export function RemoveButton({
  onClick,
  isLoading,
  size = 25,
}: {
  onClick?: any;
  isLoading?: boolean;
  size?: number;
}) {
  return (
    <ActionIcon
      variant="transparent"
      radius="lg"
      loading={isLoading}
      m={size / 3}
      size={size * 1.5}
      onClick={onClick}
    >
      <IconSquareX color={COLORS.red} size={size} />
    </ActionIcon>
  );
}
